import { EnumTipoDocumento } from '../../../../api'
import { DocumentModel } from '../../../../api/Argentia/endpoints/documents/model/document'

export interface historicalFilesCardDataTableModel extends DocumentModel {
  canDownloadDocument?: boolean
}

export enum HistoricalFilesSplitButtonOptions {
  PROFILE = 'profile',
  CURVE = 'curve',
  PERIOD = 'period',
  CONSUMPTION_WITH_PROFILE_SELECTION = 'consumption_with_profile_selection',
  SEASONS_TEMPLATE = 'seasons_template',
  GENERIC_TEMPLATE = 'generic_template'
}

export interface DownloadCurrentFormData {
  documentType: EnumTipoDocumento
  supplyPointId: number
  startDate: Date
  endDate: Date
  documentId: number
}
